module.exports = __webpack_public_path__ + "media/images/empresa/emp_users-846184fdfaff3ea6875e5bb1b208d9f9.svg";